import { ReactNode } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

const StyledFixedWith = styled.div<{ maxWidth: string | undefined }>`
  display: block;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  margin-right: auto;
  margin-left: auto;
`;

export type FixedWidthProps = {
  children: ReactNode;
  id?: string;
  maxWidth?: string;
};

export const FixedWidth = ({
  children,
  id,
  maxWidth = spacing.normalPageMaxWidth,
  ...props
}: FixedWidthProps) => {
  return (
    <StyledFixedWith data-test="fixed-width" id={id} maxWidth={maxWidth} {...props}>
      {children}
    </StyledFixedWith>
  );
};
